import type { RootState } from "@/store/store";
import type { Board } from "@/types/common";
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

type PreloadedData<T> = {
  data: T;
  isLoading: boolean;
};

type MondaySearchState = {
  searchBoards: PreloadedData<Board[]>;
};

const initialState = {
  searchBoards: {
    data: [],
    isLoading: false,
  },
} as MondaySearchState;

const mondaySearchReducer = createSlice({
  name: "mondaySearch",
  initialState,
  reducers: {
    setSearchBoards: (state, action: PayloadAction<PreloadedData<Board[]>>) => {
      state.searchBoards = action.payload;
    },
  },
});

export const { setSearchBoards } = mondaySearchReducer.actions;

export const getSearchBoardsData = (store: RootState): PreloadedData<Board[]> => store.mondaySearch.searchBoards;

export default mondaySearchReducer.reducer;
